export default [
  {
    "id": "mat-enem-0001",
    "numero": 1501,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Para o cálculo da inflação, utiliza-se, entre ou-\ntros, o Índice Nacional de Preços ao Consumi-\ndor Amplo (IPCA), que toma como base os gas-\ntos das famílias residentes nas áreas urbanas, \ncom rendimentos mensais compreendidos entre \num e quarenta salários mínimos. O gráfico a \nseguir mostra as variações do IPCA de quatro \ncapitais brasileiras no mês de maio de 2008. \n \n \n \nCom base no gráfico, qual item foi determinante \npara a inflação de maio de 2008? \n \nA) Alimentação e bebidas.  \nB) Artigos de residência. \nC) Habitação.  \nD) Vestuário. \nE) Transportes.",
    "alternativas": {
      "A": "Alimentação e bebidas.",
      "C": "Habitação.",
      "D": "Vestuário.",
      "E": "Transportes."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 1,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0002",
    "numero": 1502,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "No calendário utilizado atualmente, os anos são \nnumerados em uma escala sem o zero, isto é, \nnão existe o ano zero. A era cristã se inicia no \nano 1 depois de Cristo (d.C.) e designa-se o ano \nanterior a esse como ano 1 antes de Cristo \n(a.C.). Por essa razão, o primeiro século ou \nintervalo de 100 anos da era cristã terminou no \ndia 31 de dezembro do ano 100 d.C., quando \nhaviam decorrido os primeiros 100 anos após o \ninício da era. O século II começou no dia 1 de \njaneiro do ano 101 d.C., e assim sucessivamente. \n \nComo não existe o ano zero, o intervalo entre os \nanos 50 a.C. e 50 d.C., por exemplo, é de 100 \nanos. Outra forma de representar anos é utili-\nzando-se números inteiros, como fazem os as-\ntrônomos. Para eles, o ano 1 a.C. corresponde \nao ano 0, o ano 2 a.C. ao ano – 1, e assim su-\ncessivamente. Os anos depois de Cristo são \nrepresentados pelos números inteiros positivos, \nfazendo corresponder o número 1 ao ano 1 d.C. \n \nConsiderando o intervalo de 3 a.C. a 2 d.C., o \nquadro que relaciona as duas contagens descri-\ntas no texto é: \nA) \n \n \nB) \n \n \nC)  \n \n \nD) \n \n \nE)",
    "alternativas": {
      "A": "",
      "B": "",
      "D": "",
      "E": ""
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 2,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-0003",
    "numero": 1503,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Na cidade de João e Maria, haverá shows em \numa boate. Pensando em todos, a boate propôs \npacotes para que os fregueses escolhessem o \nque seria melhor para si. \n \nPacote 1: taxa de 40 reais por show. \n \nPacote 2: taxa de 80 reais mais 10 reais por show. \n \nPacote 3: taxa de 60 reais para 4 shows, e 15 \nreais por cada show a mais. \n \nJoão assistirá a 7 shows e Maria, a 4. As melho-\nres opções para João e Maria são, respectiva-\nmente, os pacotes: \n \nA) 1 e 2. \nB) 2 e 2.  \nC) 3 e 1.  \nD) 2 e 1. \nE) 3 e 3.",
    "alternativas": {
      "E": "3 e 3.",
      "A": "1 e 2.",
      "B": "2 e 2.",
      "C": "3 e 1."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 3,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0004",
    "numero": 1504,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Um decorador utilizou um único tipo de trans-\nformação geométrica para compor pares de \ncerâmicas em uma parede. Uma das composi-\nções está representada pelas cerâmicas indica-\ndas por I e II. \n \n \n \nUtilizando a mesma transformação, qual é a \nfigura que compõe par com a cerâmica indicada \npor III? \n \nA) \n \n \n \nB) \n \n \n \nC) \n \n \n \nD) \n \n \n \nE)",
    "alternativas": {
      "C": "",
      "D": "",
      "A": "",
      "B": ""
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 4,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-0005",
    "numero": 1505,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Cinco equipes A, B, C, D e E disputaram uma \nprova de gincana na qual as pontuações recebi-\ndas podiam ser 0, 1, 2 ou 3. A média das cinco \nequipes foi de 2 pontos. \n \nAs notas das equipes foram colocadas no gráfi-\nco a seguir, entretanto, esqueceram de repre-\nsentar as notas da equipe D e da equipe E. \n \n \nMesmo sem aparecer as notas das equipes D e \nE, pode-se concluir que os valores da moda e \nda mediana são, respectivamente, \n \nA) 1,5 e 2,0.  \nB) 2,0 e 1,5.  \nC) 2,0 e 2,0. \nD) 2,0 e 3,0. \nE) 3,0 e 2,0.",
    "alternativas": {
      "E": "3,0 e 2,0.",
      "B": "2,0 e 1,5.",
      "C": "2,0 e 2,0.",
      "D": "2,0 e 3,0."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 5,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0006",
    "numero": 1506,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Muitas vezes o objetivo de um remédio é au-\nmentar a quantidade de uma ou mais substân-\ncias já existentes no corpo do indivíduo para \nmelhorar as defesas do organismo. Depois de \nalcançar o objetivo, essa quantidade deve voltar \nao normal. \n \nSe uma determinada pessoa ingere um medi-\ncamento para aumentar a concentração da \nsubstância A em seu organismo, a quantidade \ndessa substância no organismo da pessoa, em \nrelação ao tempo, pode ser melhor apresentada \npelo gráfico: \n \nA)  \n \n \nB) \nC)  \n \n \nD) \n \n \nE)",
    "alternativas": {
      "E": "",
      "A": "",
      "C": "",
      "D": ""
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 6,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-0007",
    "numero": 1507,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "O xadrez é jogado por duas pessoas. Um joga-\ndor joga com as peças brancas, o outro, com as \npretas. Neste jogo, vamos utilizar somente a \nTorre, uma das peças do xadrez. Ela pode mo-\nver-se para qualquer casa ao longo da coluna \nou linha que ocupa, para frente ou para trás, \nconforme indicado na figura a seguir. \n \n \n \nO jogo consiste em chegar a um determinado \nponto sem passar por cima dos pontos pretos já \nindicados. \n \n \n \nRespeitando-se o movimento da peça Torre e \nas suas regras de movimentação no jogo, qual é \no menor número de movimentos possíveis e \nnecessários para que a Torre chegue à casa \nC1? \n \nA) 2  \nB) 3  \nC) 4  \nD) 5  \nE) 7",
    "alternativas": {
      "A": "2",
      "B": "3",
      "C": "4",
      "E": "7"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 7,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0008",
    "numero": 1508,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Paulo emprestou R$ 5.000,00 a um amigo, a \numa taxa de juros simples de 3% ao mês. Con-\nsidere x o número de meses do empréstimo e \nM(x) o montante a ser devolvido para Paulo no \nfinal de meses.  \n \nNessas condições, a representação gráfica cor-\nreta para M(x) é: \n \nA)  \n \n \nB) \nC) \n \n \nD) \n \n \nE)",
    "alternativas": {
      "E": "",
      "A": "",
      "B": "",
      "C": ""
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 8,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-0009",
    "numero": 1509,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Os calendários usados pelos diferentes povos \nda Terra são muito variados. O calendário islâ-\nmico, por exemplo, é lunar, e nele cada mês \ntem sincronia com a fase da lua. O calendário \nmaia segue o ciclo de Vênus, com cerca de 584 \ndias, e cada 5 ciclos de Vênus corresponde a 8 \nanos de 365 dias da Terra.  \n \nQuantos ciclos teria, em Vênus, um período \nterrestre de 48 anos? \n \nA) 30 ciclos.  \nB) 40 ciclos.  \nC) 73 ciclos. \nD) 240 ciclos.  \nE) 384 ciclos.",
    "alternativas": {
      "A": "30 ciclos.",
      "B": "40 ciclos.",
      "C": "73 ciclos.",
      "D": "240 ciclos."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 9,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0010",
    "numero": 1510,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Considere que as médias finais dos alunos de \num curso foram representadas no gráfico a se-\nguir. \n \n \nSabendo que a média para aprovação nesse \ncurso era maior ou igual a 6,0, qual foi a porcen-\ntagem de alunos aprovados? \n \nA) 18%  \nB) 21%  \nC) 36%  \nD) 50%  \nE) 72%",
    "alternativas": {
      "D": "50%",
      "E": "72%",
      "B": "21%",
      "C": "36%"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 10,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0011",
    "numero": 1511,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "As abelhas domesticadas da América do Norte \ne da Europa estão desaparecendo, sem qual-\nquer motivo. As abelhas desempenham papel \nfundamental na agricultura, pois são responsá-\nveis pela polinização (a fecundação das plan-\ntas). Anualmente, apicultores americanos alu-\ngam 2 milhões de colmeias para polinização de \nlavouras. O sumiço das abelhas já inflacionou o \npreço de locação das colmeias. No ano passa-\ndo, o aluguel de cada caixa (colmeia) com \n50.000 abelhas estava na faixa de 75 dólares. \nDepois do ocorrido, aumentou para 150 dólares. \nA previsão é que faltem abelhas para poliniza-\nção neste ano nos EUA. Somente as lavouras \nde amêndoa da Califórnia necessitam de 1,4 \nmilhão de colmeias. \n \nDe acordo com essas informações, o valor a ser \ngasto pelos agricultores das lavouras de amên-\ndoa da Califórnia com o aluguel das colmeias \nserá de: \n \nA) 4,2 mil dólares. \nB) 105 milhões de dólares. \nC) 150 milhões de dólares. \nD) 210 milhões de dólares. \nE) 300 milhões de dólares.",
    "alternativas": {
      "A": "4,2 mil dólares.",
      "C": "150 milhões de dólares.",
      "D": "210 milhões de dólares.",
      "E": "300 milhões de dólares."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 11,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0012",
    "numero": 1512,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Em uma padaria, há dois tipos de forma de bolo, \nformas 1 e 2, como mostra na sequência. Sejam \nL o lado da base da forma quadrada, r o raio da \nbase da forma redonda, A1 e A2 as áreas das \nbases das formas 1 e 2, e V1 e V2 os seus vo-\nlumes, respectivamente. \n \n \nSe as formas têm a mesma altura h, para que \nelas comportem a mesma quantidade de massa \nde bolo, qual é a relação entre r e L? \n \nA) L = r  \nB) L = 2r  \nC) L = r \nD) L = r√𝜋 \nE) L = (𝜋 r2)/2",
    "alternativas": {
      "B": "L = 2r",
      "D": "L = r√𝜋",
      "E": "L = (𝜋 r2)/2",
      "A": "L = r"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 12,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0013",
    "numero": 1513,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Dados do Instituto de Pesquisas Econômicas \nAplicadas (IPEA) revelaram que no biênio \n2004/2005, nas rodovias federais, os atropela-\nmentos com morte ocuparam o segundo lugar \nno ranking de mortalidade por acidente. A cada \n34 atropelamentos, ocorreram 10 mortes. Cerca \nde 4 mil atropelamentos/ano, um a cada duas \nhoras, aproximadamente. \n \nDe acordo com os dados, se for escolhido alea-\ntoriamente para investigação mais detalhada um \ndos \natropelamentos \nocorridos \nno \nbiênio \n2004/2005, a probabilidade de ter sido um atro-\npelamento sem morte é: \nA) 2/17 \nB) 5/17 \nC) 2/5 \nD) 3/5 \nE) 12/17",
    "alternativas": {
      "B": "5/17",
      "C": "2/5",
      "E": "12/17",
      "A": "2/17"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 13,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0014",
    "numero": 1514,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Em um determinado semáforo, as luzes comple-\ntam um ciclo de verde, amarelo e vermelho em \n1 minuto e 40 segundos. Desse tempo, 25 se-\ngundos são para a luz verde, 5 segundos para a \namarela e 70 segundos para a vermelha. Ao se \naproximar do semáforo, um veículo tem uma \ndeterminada probabilidade de encontrá-lo na luz \nverde, amarela ou vermelha. Se essa aproxima-\nção for de forma aleatória, pode-se admitir que \na probabilidade de encontrá-lo com uma dessas \ncores é diretamente proporcional ao tempo em \nque cada uma delas fica acesa. \n \nSuponha que um motorista passa por um semá-\nforo duas vezes ao dia, de maneira aleatória e \nindependente uma da outra. Qual é a probabili-\ndade de o motorista encontrar esse semáforo \ncom a luz verde acesa nas duas vezes em que \npassar? \n \nA) 1/25 \nB) 1/16 \nC) 1/9 \nD) 1/3 \nE) 1/2",
    "alternativas": {
      "A": "1/25",
      "B": "1/16",
      "C": "1/9",
      "D": "1/3"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 14,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0016",
    "numero": 1516,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "A importância do desenvolvimento da atividade \nturística no Brasil relaciona-se especialmente \ncom os possíveis efeitos na redução da pobreza \ne das desigualdades por meio da geração de \nnovos postos de trabalho e da contribuição para \no desenvolvimento sustentável regional. \n \nNo gráfico são mostrados três cenários – pes-\nsimista, previsível, otimista – a respeito da gera-\nção de empregos pelo desenvolvimento de ati-\nvidades turísticas. \n \n \n \nDe acordo com o gráfico, em 2009, o número de \nempregos gerados pelo turismo será superior a: \n \nA) 602.900 no cenário previsível. \nB) 660.000 no cenário otimista. \nC) 316.000 e inferior a 416.000 no cenário pre-\nvisível. \nD) 235.700 e inferior a 353.800 no cenário pes-\nsimista. \nE) 516.000 e inferior a 616.000 no cenário oti-\nmista.",
    "alternativas": {
      "A": "602.900 no cenário previsível.",
      "C": "316.000 e inferior a 416.000 no cenário pre- visível.",
      "D": "235.700 e inferior a 353.800 no cenário pes- simista.",
      "E": "516.000 e inferior a 616.000 no cenário oti- mista."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 16,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0017",
    "numero": 1517,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Pneus usados geralmente são descartados de \nforma inadequada, favorecendo a proliferação \nde insetos e roedores e provocando sérios pro-\nblemas de saúde pública. Estima-se que, no \nBrasil, a cada ano, sejam descartados 20 mi-\nlhões de pneus usados. Como alternativa para \ndar uma destinação final a esses pneus, a Pe-\ntrobras, em sua unidade de São Mateus do Sul, \nno Paraná, desenvolveu um processo de obten-\nção de combustível a partir da mistura dos \npneus com xisto. Esse procedimento permite, a \npartir de uma tonelada de pneu, um rendimento \nde cerca de 530 kg de óleo. \n \nConsiderando que uma tonelada corresponde, \nem média, a cerca de 200 pneus, se todos os \npneus descartados anualmente fossem utiliza-\ndos no processo de obtenção de combustível \npela mistura com xisto, seriam então produzi-\ndas: \n \nA) 5,3 mil toneladas de óleo. \nB) 53 mil toneladas de óleo. \nC) 530 mil toneladas de óleo. \nD) 5,3 milhões de toneladas de óleo. \nE) 530 milhões de toneladas de óleo.",
    "alternativas": {
      "E": "530 milhões de toneladas de óleo.",
      "A": "5,3 mil toneladas de óleo.",
      "B": "53 mil toneladas de óleo.",
      "D": "5,3 milhões de toneladas de óleo."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 17,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0018",
    "numero": 1518,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Uma empresa produz jogos pedagógicos para \ncomputadores, com custos fixos de R$ 1.000,00 \ne custos variáveis de R$ 100,00 por unidade de \njogo produzida. Desse modo, o custo total para \nx jogos produzidos é dado por:  \n \nC(x) = 1 + 0,1x (em R$ 1.000,00). \n \nA gerência da empresa determina que o preço \nde venda do produto seja de R$ 700,00. Com \nisso a receita bruta para x jogos produzidos é \ndada por R(x) = 0,7x (em R$ 1.000,00).  \n \nO lucro líquido, obtido pela venda de x unidades \nde jogos, é calculado pela diferença entre a \nreceita bruta e os custos totais. \n \nO gráfico que modela corretamente o lucro lí-\nquido dessa empresa, quando são produzidos x \njogos, é: \nA) \n \n \nB) \n \n \nC)  \n \n \nD) \n \nE)",
    "alternativas": {
      "A": "",
      "B": "",
      "C": "",
      "E": ""
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 18,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-0019",
    "numero": 1519,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Três empresas de táxi W, K e L estão fazendo \npromoções: a empresa W cobra R$ 2,40 a cada \nquilômetro rodado e com um custo inicial de R$ \n3,00; a empresa K cobra R$ 2,25 a cada quilô-\nmetro rodado e uma taxa inicial de R$ 3,80 e, \npor fim, a empresa L, que cobra R$ 2,50 a cada \nquilômetro rodado e com taxa inicial de R$ 2,80. \nUm executivo está saindo de casa e vai de táxi \npara uma reunião que é a 5 km do ponto de táxi, \ne sua esposa sairá do hotel e irá para o aero-\nporto, que fica a 15 km do ponto de táxi. \n \nAssim, os táxis que o executivo e sua esposa \ndeverão pegar, respectivamente, para terem a \nmaior economia são das empresas: \n \nA) W e L.  \nB) W e K.  \nC) K e L. \nD) K e W.  \nE) K e K.",
    "alternativas": {
      "B": "W e K.",
      "C": "K e L.",
      "D": "K e W.",
      "A": "W e L."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 19,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0020",
    "numero": 1520,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Uma pessoa decidiu depositar moedas de 1, 5, \n10, 25 e 50 centavos em um cofre durante certo \ntempo. Todo dia da semana ela depositava uma \núnica moeda, sempre nesta ordem: 1, 5, 10, 25, \n50, e, novamente, 1, 5, 10, 25, 50, assim suces-\nsivamente. Se a primeira moeda foi depositada \nem uma segunda-feira, então essa pessoa con-\nseguiu a quantia exata de R$ 95,05 após depo-\nsitar a moeda de: \n \nA) 1 centavo no 679º dia, que caiu numa segun-\nda-feira. \nB) 5 centavos no 186º dia, que caiu numa quin-\nta-feira. \nC) 10 centavos no 188ºdia, que caiu numa quin-\nta-feira. \nD) 25 centavos no 524º dia, que caiu num sába-\ndo. \nE) 50 centavos no 535º dia, que caiu numa quin-\nta-feira.",
    "alternativas": {
      "C": "10 centavos no 188ºdia, que caiu numa quin- ta-feira.",
      "D": "25 centavos no 524º dia, que caiu num sába- do.",
      "E": "50 centavos no 535º dia, que caiu numa quin- ta-feira.",
      "B": "5 centavos no 186º dia, que caiu numa quin- ta-feira."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 20,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0021",
    "numero": 1521,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Segundo a Associação Brasileira de Alumínio \n(ABAL), o Brasil foi o campeão mundial, pelo \nsétimo ano seguido, na reciclagem de latas de \nalumínio. Foi reciclado 96,5% do que foi utiliza-\ndo no mercado interno em 2007, o equivalente a \n11,9 bilhões de latinhas. Este número significa, \nem média, um movimento de 1,8 bilhão de reais \nanuais em função da reutilização de latas no \nBrasil, sendo 523 milhões referentes à etapa da \ncoleta, gerando, assim, “emprego” e renda para \ncerca de 180 mil trabalha dores. Essa renda, em \nmuitos casos, serve como complementação do \norçamento familiar e, em outros casos, como \núnica renda da família. \n \nCom base nas informações apresentadas, a \nrenda média mensal dos trabalhadores envolvi-\ndos nesse tipo de coleta gira em tomo de: \n \nA) R$173,00.  \nB) R$ 242,00.  \nC) R$ 343,00. \nD) R$ 504,00.  \nE) R$ 841,00.",
    "alternativas": {
      "E": "R$ 841,00.",
      "A": "R$173,00.",
      "B": "R$ 242,00.",
      "D": "R$ 504,00."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 21,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0022",
    "numero": 1522,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Nos últimos anos, o aumento da população, \naliado ao crescente consumo de água, tem ge-\nrado inúmeras preocupações, incluindo o uso \ndesta na produção de alimentos. \n \nO gráfico mostra a quantidade de litros de água \nnecessária para a produção de 1 kg de alguns \nalimentos. \n \n \n \nCom base no gráfico, para a produção de 100 \nkg de milho, 100 kg de trigo, 100 kg de arroz, \n100 kg de carne de porco e 600 kg de carne de \nboi, a quantidade média necessária de água, \npor quilograma de alimento produzido, é apro-\nximadamente igual a: \n \nA) 415 litros por quilograma. \nB) 11 200 litros por quilograma. \nC) 27 000 litros por quilograma. \nD) 2 240 000 litros por quilograma. \nE) 2 700 000 litros por quilograma.",
    "alternativas": {
      "A": "415 litros por quilograma.",
      "B": "11 200 litros por quilograma.",
      "D": "2 240 000 litros por quilograma.",
      "E": "2 700 000 litros por quilograma."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 22,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0023",
    "numero": 1523,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Uma empresa precisa comprar uma tampa para \no seu reservatório, que tem a forma de um tron-\nco de cone circular reto, conforme mostrado na \nfigura. \n \n \n \nConsidere que a base do reservatório tenha raio \nr = 23m e que sua lateral faça um ângulo de 60° \ncom o solo. Se a altura do reservatório é 12m, a \ntampa a ser comprada deverá cobrir uma área \nde: \n \nA) 12𝜋 m2.  \nB) 108𝜋 m2. \nC) (12 𝜋 + 2√3)2 𝜋 m2.  \nD) 300 𝜋 m2. \nE) (24 + 2√3)2 𝜋 m2.",
    "alternativas": {
      "B": "108𝜋 m2.",
      "C": "(12 𝜋 + 2√3)2 𝜋 m2.",
      "E": "(24 + 2√3)2 𝜋 m2.",
      "A": "12𝜋 m2."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 23,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0024",
    "numero": 1524,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "A fotografia mostra uma turista aparentemente \nbeijando a esfinge de Gizé, no Egito. A figura a \nseguir mostra como, na verdade, foram posicio-\nnadas a câmera fotográfica, a turista e a esfin-\nge. \n \n \nMedindo-se com uma régua diretamente na \nfotografia, verifica-se que a medida do queixo \naté o alto da cabeça da turista é igual a 2/3 da \nmedida do queixo da esfinge até o alto da sua \ncabeça. Considere que essas medidas na reali-\ndade são representadas por de d e d’, respecti-\nvamente, que a distância da esfinge à lente da \ncâmera fotográfica, localizada no plano horizon-\ntal do queixo da turista e da esfinge, é represen-\ntada por b, e que a distância da turista à mesma \nlente, por a. \n \nA razão entre b e a será dada por: \n \nA) \nb\na = \nd´\nc  \n \nB) \nb\na = \n2d\n3c \n \nC) \nb\na = \n3d´\n2c \n \nD) \nb\na = \n2d´\n3c \n \nE) \nb\na = \n2d\nc",
    "alternativas": {
      "A": "b a = d´ c",
      "B": "b a = 2d 3c",
      "C": "b a = 3d´ 2c",
      "D": "b a = 2d´ 3c"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 24,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0025",
    "numero": 1525,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Uma fotografia tirada em uma câmera digital é \nformada por um grande número de pontos, de-\nnominados pixels. Comercialmente, a resolução \nde uma câmera digital é especificada indicando \nos milhões de pixels, ou seja, os megapixels de \nque são constituídas as suas fotos.  \n \nAo se imprimir uma foto digital em papel fotográ-\nfico, esses pontos devem ser pequenos para \nque não sejam distinguíveis a olho nu. A resolu-\nção de uma impressora é indicada pelo termo \ndpi (dot per inch) , que é a quantidade de pontos \nque serão impressos em uma linha com uma \npolegada de comprimento. Uma foto impressa \ncom 300 dpi, que corresponde a cerca de 120 \npontos por centímetro, terá boa qualidade visu-\nal, já que os pontos serão tão pequenos, que o \nolho não será capaz de vê-los separados e pas-\nsará a ver um padrão contínuo. \n \nPara se imprimir uma foto retangular de 15 cm \npor 20 cm, com resolução de pelo menos 300 \ndpi, qual é o valor aproximado de megapixels \nque a foto terá? \n \nA) 1,00 megapixel.  \nB) 2,52 megapixels. \nC) 2,70 megapixels.  \nD) 3,15 megapixels. \nE) 4,32 megapixels.",
    "alternativas": {
      "C": "2,70 megapixels.",
      "D": "3,15 megapixels.",
      "E": "4,32 megapixels.",
      "B": "2,52 megapixels."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 25,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0026",
    "numero": 1526,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "A taxa anual de desmatamento na Amazônia é \ncalculada com dados de satélite, pelo Instituto \nNacional de Pesquisas Espaciais (INPE), de 10 \nde agosto de um ano a 31 de julho do ano se-\nguinte. No mês de julho de 2008, foi registrado \nque o desmatamento acumulado nos últimos 12 \nmeses havia sido 64% maior do que no ano \nanterior, quando o INPE registrou 4.974 km2 de \nfloresta desmatada. Nesses mesmos 12 meses \nacumulados, somente o estado de Mato Grosso \nfoi responsável por, aproximadamente, 56% da \nárea total desmatada na Amazônia. \n \nDe acordo com os dados, a área desmatada \nsob a responsabilidade do estado do Mato \nGrosso, em julho de 2008, foi: \n \nA) inferior a 2.500 km2. \nB) superior a 2.500 km2 e inferior a 3.000 km2. \nC) superior a 3.000 km2 e inferior a 3.900 km2. \nD) superior a 3.900 km2 e inferior a 4.700 km2. \nE) superior a 4.700 km2.",
    "alternativas": {
      "E": "superior a 4.700 km2.",
      "A": "inferior a 2.500 km2.",
      "C": "superior a 3.000 km2 e inferior a 3.900 km2.",
      "D": "superior a 3.900 km2 e inferior a 4.700 km2."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 26,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0028",
    "numero": 1528,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Considere um caminhão que tenha uma carro-\nceria na forma de um paralelepípedo retângulo, \ncujas dimensões internas são 5,1m de compri-\nmento, 2,1m de largura e 2,1m de altura. Supo-\nnha que esse caminhão foi contratado para \ntransportar 240 caixas na forma de cubo com \n1m de aresta cada uma e que essas caixas \npodem ser empilhadas para o transporte.  \n \nQual é o número mínimo de viagens necessá-\nrias para realizar esse transporte? \n \nA) 10 viagens.  \nB) 11 viagens.  \nC) 12 viagens. \nD) 24 viagens.  \nE) 27 viagens.",
    "alternativas": {
      "B": "11 viagens.",
      "C": "12 viagens.",
      "E": "27 viagens.",
      "A": "10 viagens."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 28,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0029",
    "numero": 1529,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Diante de um sanduíche e de uma porção de \nbatatas fritas, um garoto, muito interessado na \nquantidade de calorias que pode ingerir em \ncada refeição, analisa os dados de que dispõe. \nEle sabe que a porção de batatas tem 200 g, o \nque equivale a 560 calorias, e que o sanduíche \ntem 250g e 500 calorias. Como ele deseja co-\nmer um pouco do sanduíche e um pouco das \nbatatas, ele se vê diante da questão: \"Quantos \ngramas de sanduíche e quantos gramas de \nbatata eu posso comer para ingerir apenas as \n462 calorias permitidas para esta refeição?\" \n \nConsiderando que x e y representam, respecti-\nvamente, em gramas, as quantidades do sandu-\níche e das batatas que o garoto pode ingerir, \nassinale a altemativa correspondente à expres-\nsão a: \n \nA) 2x + 2,8y = 462  \n \nB) 2,8x + 2y = 462 \n \nC) 1,8x + 2,3y = 1.060  \n \nD) \n1\n2x + 0,4y = 462 \n \nE) 0,4x + \n1\n2y = 462",
    "alternativas": {
      "A": "2x + 2,8y = 462",
      "B": "2,8x + 2y = 462",
      "C": "1,8x + 2,3y = 1.060",
      "D": "1 2x + 0,4y = 462"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 29,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0030",
    "numero": 1530,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Um chefe de cozinha utiliza um instrumento \ncilíndrico afiado para retirar parte do miolo de \numa laranja. Em seguida, ele fatia toda a laranja \nem secções perpendiculares ao corte feito pelo \ncilindro. Considere que o raio do cilindro e da \nlaranja sejam iguais a 1 cm e a 3 cm, respecti-\nvamente. \n \nA área da maior fatia possível é: \n \nA) duas vezes a área da secção transversal do \ncilindro. \nB) três vezes a área da secção transversal do \ncilindro. \nC) quatro vezes a área da secção transversal do \ncilindro. \nD) seis vezes a área da secção transversal do \ncilindro. \nE) oito vezes a área da secção transversal do \ncilindro.",
    "alternativas": {
      "D": "seis vezes a área da secção transversal do cilindro.",
      "E": "oito vezes a área da secção transversal do cilindro.",
      "B": "três vezes a área da secção transversal do cilindro.",
      "C": "quatro vezes a área da secção transversal do cilindro."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 30,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0031",
    "numero": 1531,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Depois de jogar um dado em forma de cubo e \nde faces numeradas de 1 a 6, por 10 vezes \nconsecutivas, e anotar o número obtido em ca-\nda jogada, construiu-se a seguinte tabela de \ndistribuição de frequências. \n \nNÚMERO \nOBTIDO \nFREQUÊNCIA \n1 \n4 \n2 \n1 \n4 \n2 \n5 \n2 \n6 \n1 \n \nA média, mediana e moda dessa distribuição de \nfrequências são, respectivamente: \n \nA) 3, 2 e 1  \nB) 3, 3 e 1  \nC) 3, 4 e 2 \nD) 5, 4 e 2  \nE) 6, 2 e 4",
    "alternativas": {
      "B": "3, 3 e 1",
      "D": "5, 4 e 2",
      "E": "6, 2 e 4",
      "A": "3, 2 e 1"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 31,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0032",
    "numero": 1532,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Um vasilhame na forma de um cilindro circular \nreto de raio da base de 5 cm e altura de 30 cm \nestá parcialmente ocupado por 625𝜋 cm3 de \nálcool.  \n \n \n \nSuponha que sobre o vasilhame seja fixado um \nfunil na forma de um cone circular reto de raio \nda base de 5 cm e altura de 6 cm, conforme \nilustra a figura 1. O conjunto, como mostra a \nfigura 2, é virado para baixo, sendo H a distân-\ncia da superfície do álcool até o fundo do vasi-\nlhame. Volume do cone: \n \nVcone = \nπr2h\n3  \n \nConsiderando-se essas informações, qual é o \nvalor da distância H? \n \nA) 5 cm.  \nB) 7 cm.  \nC) 8 cm. \nD) 12 cm.  \nE) 18 cm.",
    "alternativas": {
      "D": "12 cm.",
      "E": "18 cm.",
      "A": "5 cm.",
      "B": "7 cm."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 32,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0034",
    "numero": 1534,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Em um concurso realizado em uma lanchonete, \napresentavam-se ao consumidor quatro cartas \nvoltadas para baixo, em ordem aleatória, dife-\nrenciadas pelos algarismos 0, 1, 2 e 5. O con-\nsumidor selecionava uma nova ordem ainda \ncom as cartas voltadas para baixo. Ao desvirá-\nlas, verificava-se quais delas continham o alga-\nrismo na posição correta dos algarismos do \nnúmero 12,50 que era o valor, em reais, do trio-\npromoção. Para cada algarismo na posição \nacertada, ganhava-se R$ 1,00 de desconto. Por \nexemplo, se a segunda carta da sequência es-\ncolhida pelo consumidor fosse 2 e a terceira \nfosse 5, ele ganharia R$ 2,00 de desconto. \n \nQual é a probabilidade de um consumidor não \nganhar qualquer desconto? \n \nA) 1/24 \nB) 3/24 \nC) 1/3 \nD) 1/4 \nE) 1/2",
    "alternativas": {
      "C": "1/3",
      "D": "1/4",
      "A": "1/24",
      "B": "3/24"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 34,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0035",
    "numero": 1535,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "No mundial de 2007, o americano Bernard La-\ngat, usando pela primeira vez uma sapatilha \n34% mais leve do que a média, conquistou o \nouro na corrida de 1.500 metros com um tempo \nde 3,58 minutos. No ano anterior, em 2006, ele \nhavia ganhado medalha de ouro com um tempo \nde 3,65 minutos nos mesmos 1.500 metros. \n \nSendo assim, a velocidade média do atleta au-\nmentou em aproximadamente: \n \nA) 1,05%.  \nB) 2,00%.  \nC) 4,11%. \nD) 4,19%.  \nE) 7,00%.",
    "alternativas": {
      "D": "4,19%.",
      "E": "7,00%.",
      "B": "2,00%.",
      "C": "4,11%."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 35,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0036",
    "numero": 1536,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "No depósito de uma biblioteca há caixas con-\ntendo folhas de papel de 0,1 mm de espessura, \ne em cada uma delas estão anotados 10 títulos \nde livros diferentes. Essas folhas foram empi-\nlhadas formando uma torre vertical de 1 m de \naltura. Qual a representação, em potência de \n10, correspondente à quantidade de títulos de \nlivros registrados nesse em pilhamento? \n \nA) 102  \nB) 104  \nC) 105  \nD) 106  \nE) 107",
    "alternativas": {
      "D": "106",
      "E": "107",
      "A": "102",
      "C": "105"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 36,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0037",
    "numero": 1537,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "No quadro seguinte, são informados os turnos em que foram eleitos os prefeitos das capitais de todos os \nestados brasileiros em 2004. \n \n \n \nNa região Norte, a frequência relativa de eleição dos prefeitos no 2º turno foi, aproximadamente, \n \nA) 42,86%.  \nB) 44,44%.  \nC) 50,00%. \nD) 57,14%.  \nE) 57,69%.",
    "alternativas": {
      "A": "42,86%.",
      "B": "44,44%.",
      "D": "57,14%.",
      "E": "57,69%."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 37,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0038",
    "numero": 1538,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "A empresa WQTU Cosmético vende um deter-\nminado produto x, cujo custo de fabricação de \ncada unidade é dado por 3x2 + 232, e o seu \nvalor de venda é expresso pela função         \n180x  – 116. A empresa vendeu 10 unidades do \nproduto x, contudo a mesma deseja saber quan-\ntas unidades precisa vender para obter um lucro \nmáximo. \n \nA quantidade máxima de unidades a serem \nvendidas pela empresa WQTU para a obtenção \ndo maior lucro é: \n \nA) 10  \nB) 30  \nC) 58  \nD) 116  \nE) 232",
    "alternativas": {
      "A": "10",
      "B": "30",
      "C": "58",
      "E": "232"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 38,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0039",
    "numero": 1539,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Em uma praça pública, há uma fonte que é for-\nmada por dois cilindros, um de raio r e altura h1, \ne o outro de raio R e altura h2. O cilindro do \nmeio enche e, após transbordar, começa a en-\ncher o outro. \nSe R = r√2 e h2 = \nh1\n3 , para encher o cilindro do \nmeio, foram necessários 30 minutos, então, \npara se conseguir encher essa fonte e o segun-\ndo cilindro, de modo que fique completamente \ncheio, serão necessários: \n \nA) 20 minutos.  \nB) 30 minutos.  \nC) 40 minutos. \nD) 50 minutos.  \nE) 60 minutos.",
    "alternativas": {
      "A": "20 minutos.",
      "B": "30 minutos.",
      "C": "40 minutos.",
      "D": "50 minutos."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 39,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0040",
    "numero": 1540,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Um comerciante contratou um novo funcionário \npara cuidar das vendas. Combinou pagar a essa \npessoa R$ 120,00 por semana, desde que as \nvendas se mantivessem em torno de R$ 600,00 \nsemanais e, como um estímulo, também propôs \nque na semana na qual ele vendesse R$ \n1.200,00, ele receberia R$ 200,00, em vez de \nR$ 120,00. \n \nAo término da primeira semana, esse novo fun-\ncionário conseguiu aumentar as vendas para R$ \n990,00 e foi pedir ao seu patrão um aumento \nproporcional ao que conseguiu aumentar nas \nvendas. O patrão concordou e, após fazer al-\ngumas contas, pagou ao funcionário a quantia \nde: \n \nA) R$ 160,00.  \nB) R$ 165,00.  \nC) R$ 172,00. \nD) R$ 180,00.  \nE) R$ 198,00.",
    "alternativas": {
      "D": "R$ 180,00.",
      "E": "R$ 198,00.",
      "B": "R$ 165,00.",
      "C": "R$ 172,00."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 40,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0041",
    "numero": 1541,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Uma pesquisa foi realizada para tentar desco-\nbrir, do ponto de vista das mulheres, qual é o \nperfil da parceira ideal procurada pelo homem \ndo séc. XXI. Alguns resultados estão apresen-\ntados no quadro abaixo. \n \n \n \nSe a pesquisa foi realizada com 300 mulheres, \nentão a quantidade delas que acredita que os \nhomens odeiam ir ao shopping e pensa que eles \npreferem que elas façam todas as tarefas da \ncasa é: \nA) inferior a 80. \nB) superior a 80 e inferior a 100. \nC) superior a 100 e inferior a 120. \nD) superior a 120 e inferior a 140. \nE) superior a 140.",
    "alternativas": {
      "E": "superior a 140.",
      "A": "inferior a 80.",
      "C": "superior a 100 e inferior a 120.",
      "D": "superior a 120 e inferior a 140."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 41,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0042",
    "numero": 1542,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Um artista plástico construiu, com certa quanti-\ndade de massa modeladora, um cilindro circular \nreto cujo diâmetro da base mede 24 cm e cuja \naltura mede 15 cm. Antes que a massa secas-\nse, ele resolveu transformar aquele cilindro em \numa esfera. Volume da esfera: \n \nVesfera = \n4πr3\n3  \n \nAnalisando as características das figuras geo-\nmétricas envolvidas, conclui-se que o raio R da \nesfera assim construída é igual a: \n \nA) 15  \nB) 12  \nC) 24 \nD) 3√60\n3\n \nE) 6√30\n3",
    "alternativas": {
      "E": "6√30 3",
      "A": "15",
      "B": "12",
      "D": "3√60 3"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 42,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0043",
    "numero": 1543,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "A empresa SWK produz um determinado produ-\nto x, cujo custo de fabricação é dado pela equa-\nção de uma reta crescente, com inclinação dois \ne de variável x. Se não tivermos nenhum produ-\nto produzido, a despesa fixa é de R$ 7,00 e a \nfunção venda de cada unidade x é dada por: \n \n– 2x2 + 229,76x – 441,84. \n \nTendo em vista uma crise financeira, a empresa \nfez algumas demissões. Com isso, caiu em 12% \no custo da produção de cada unidade produzi-\nda. Nessas condições, a função lucro da em-\npresa pode ser expressa como: \n \nA) L(x)= – 2x2 + 228x – 448,00 \nB) L(x)= – 2x2 + 227, 76x – 448,84 \nC) L(x)= – 2x2 + 228x – 441 ,84 \nD) L(x)= – 2x2 + 229,76x – 441,84 \nE) L(x)= – 2x2 + 227, 76x – 448,96",
    "alternativas": {
      "C": "L(x)= – 2x2 + 228x – 441 ,84",
      "E": "L(x)= – 2x2 + 227, 76x – 448,96",
      "A": "L(x)= – 2x2 + 228x – 448,00",
      "B": "L(x)= – 2x2 + 227, 76x – 448,84"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.1",
    "numeroOriginal": 43,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];